export const visitorSiteConfig = {
  siteId: "firestone",
  siteName: "Firestone",
  excludedPathPrefixes: [],
} as const;
